import { $, $body, $doc } from './_utils';

const $navigationTop = $('.vpth-navigation-top');

// Create navigation mobile.
$('<div class="vpth-navigation-mobile"></div>').appendTo($body);

// Copy navigation in the mobile.
$navigationTop.clone().removeClass('vpth-navigation-top').appendTo('.vpth-navigation-mobile');

const $navMobile = $('.vpth-navigation-mobile');

// Copy logo in the mobile.
$navigationTop
  .parents('header')
  .find('.wp-block-site-logo')
  .clone()
  .appendTo('.vpth-navigation-mobile .vpth-navigation');

// Popup show/hide events.
function showPopupEvent(show) {
  if ($navMobile.hasClass('show')) {
    $doc.trigger(show);
  }
}
function hidePopupEvent(hide) {
  if (!$navMobile.hasClass('show')) {
    $doc.trigger(hide);
  }
}

let transitionEndRepeat = false;

$doc.on('click', '.vpth-navigation > .vpth-navigation-toggle', () => {
  $navMobile.toggleClass('show');

  showPopupEvent('vpth-navigation-mobile-showing');
  hidePopupEvent('vpth-navigation-mobile-hiding');

  transitionEndRepeat = true;
});

$doc.on('transitionend webkitTransitionEnd oTransitionEnd', '.vpth-navigation-mobile', () => {
  if (false === transitionEndRepeat) {
    return;
  }

  showPopupEvent('vpth-navigation-mobile-showed');
  hidePopupEvent('vpth-navigation-mobile-hidden');

  transitionEndRepeat = false;
});

// Mobile collapse.
function hideCollapse($collapse) {
  const $collapseMenu = $collapse.children('.vpth-navigation-submenu');

  $collapseMenu
    .stop()
    .css('display', 'block')
    .slideUp(300, () => {
      $collapseMenu.css('height', '');
      $collapseMenu
        .find('.vpth-navigation-item.has-child')
        .removeClass('show')
        .children('.vpth-navigation-submenu')
        .stop()
        .css('display', 'none');
    });

  $collapse.removeClass('show');
}
function showCollapse($collapse) {
  const $collapseMenu = $collapse.children('.vpth-navigation-submenu');

  $collapseMenu
    .stop()
    .css('display', 'none')
    .slideDown(300, () => {
      $collapseMenu.css('height', '');
    });

  $collapse.addClass('show');
}
$doc.on(
  'click',
  '.vpth-navigation-mobile .vpth-navigation-item.has-child > .vpth-navigation-link',
  function (e) {
    e.preventDefault();

    const $collapse = $(this).siblings('.vpth-navigation-submenu').parent();

    if ($collapse.length) {
      const isShowed = $collapse.hasClass('show');

      if (isShowed) {
        hideCollapse($collapse);
      } else {
        showCollapse($collapse);
      }
    }
  }
);

// Keyup escape.
$doc.on('keyup', (e) => {
  if (27 === e.keyCode) {
    $navMobile.removeClass('show');

    hideCollapse($('.vpth-navigation-mobile .vpth-navigation-item.has-child.show'));

    hidePopupEvent('vpth-navigation-mobile-hiding');

    transitionEndRepeat = true;
  }
});
